import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  ChangeDetectorRef,
  Inject,
  ViewEncapsulation,
} from "@angular/core";
import { TableViewComponent } from "src/app/shared/table-view/table-view.component";
import { DeudaService } from "./deuda.service";
import { DeudaList } from "../models/deuda";
import { Persona } from "../models/persona";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material";
import { comprobante } from "../models/comprobante";
import { environment } from "src/environments/environment";
import { Overlay } from "@angular/cdk/overlay";
import { Pagos360Component } from "src/app/pagos/pagos360/pagos360.component";
import { persona } from "src/app/inicio/inicio/models/usuario";


export interface DialogData {

  codigo: string;
  descripcion: string;
  nrocta: string;
  cantdias: number;
  vienedeinicio: string;
}
@Component({
  selector: "app-deuda",
  templateUrl: "./deuda.component.html",
  styleUrls: ["./deuda.component.scss"],
  providers: [DeudaService],
  encapsulation:ViewEncapsulation.None
})
export class DeudaComponent implements OnInit {
  tributopersona: Persona;
  items: DeudaList[] = [];
  nrocta ;
  idTipoTributo=0;//paso el tipo tributo
  selected : number;
  idComprobante=0;

  comprobante: comprobante;

  public columns: object[] = [];
  public detailColumns: object[] = [];
  @ViewChild("tableView") tableView: TableViewComponent<any>;
  //@ViewChild("orderIdCellTemplate") private orderIdCellTemplate: TemplateRef<any>;
  @ViewChild("deudaCellTemplate") private orderNumberCellTemplate: TemplateRef<
    any
  >;

  numberOfRecords = 0;
  isVisible = false;
  buttonVisible = true;
  titulo = "";
  codigo = "";
  situacion = false;
  cantidad;
  resultado = [];
  arr = [];
  montoTt = 0;
  botonCedulon = false;
  botonP360 = false;
  index;
  mensaje="";
  visibleCboTributos = false;
  tipoTributos=[];// carga el combo tipo tributo
  conceptoTributo='';//variable que uso para traer el concepto abreviado del tipo tributo 
  esconderImagen=false;//esconde la imagen de fondo
  tributoPP="";//tributo para mostrar tabla de plan de pago
  tributoContribuyente="";//variable para obtener el tributo contribuyente
  arrayPago360=[];
  constructor(
    private ref: ChangeDetectorRef,
    private service: DeudaService,
    public dialog: MatDialog,
    private overlay: Overlay,
    public dialogRef: MatDialogRef<DeudaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.titulos(data.codigo, data.descripcion);
    if (data.vienedeinicio != 'N'){
      this.mensaje = "La deuda es al día de hoy. Puede seleccionar otro plazo de días.";
      this.getDeudadesdeinicio(data.nrocta, data.cantdias)
    }
  }

  ngOnInit() {
    this.service.getTributos().subscribe(data =>{this.tipoTributos = data; console.log(this.tipoTributos )});
    if(this.data.codigo == 'TAV'){
      this.visibleCboTributos =true;
    }
    this.tributoPP = this.data.codigo;
    debugger;
  }

  titulos(codigo: string, descripcion: string): void {
    this.titulo = descripcion;
    this.codigo = codigo;
  }

  getDeudadesdeinicio(p_nrocta: string, p_cantDias: number): void {
    debugger;
    
    
    if (p_nrocta != null && p_cantDias != null) {
      this.isVisible = true;
      this.service
        .getDeudaList(p_nrocta.toUpperCase(), p_cantDias, this.codigo)
        .subscribe((response) => {
          this.items = response;
          this.isVisible = false;
          this.cantidad = response.length;
          this.buttonVisible = false;
          debugger
         
          this.getPersona(p_nrocta.toUpperCase(), this.codigo);

          for (var i = 0; i < response.length; i++) {
            if (response[i].situacion_deuda == "PL") {
              this.situacion = true;
              return;
            } else if (response[i].situacion_deuda == "JU") {
              this.situacion = true;
              return;
            } else this.situacion = false;
          }
          this.montoTt = 0;
        });
    } else {
      alert("Debe ingresar el número de cuenta y cantidad de días.");
    }
  
  }
  // cargarCombo
  cargarCombo(){
    debugger
  }

  //fin de cargarCombo
  
  // fin de tasas varias


  getDeuda(p_nrocta: string, p_cantDias: number): void {
    this.mensaje = "";
    this.esconderImagen = true;
    for(var i = 0;i < this.tipoTributos.length;i++ ){
      if(this.tipoTributos[i].id_tipo_tributo == this.idTipoTributo){
        this.conceptoTributo = this.tipoTributos[i].tipo_tributo;
      }
    }

    
    
    

   

    if (p_nrocta != null && p_cantDias != null) {
      this.isVisible = true;
      this.service
        .getDeudaList(p_nrocta.toUpperCase(), p_cantDias, this.codigo,this.idTipoTributo)
        .subscribe((response) => {
          debugger
          console.log('DEUDA LIST ' + response)
          this.items = response;
          this.isVisible = false;
          this.cantidad = response.length;
          this.buttonVisible = false;
          if(this.codigo == 'TAV'){
            this.codigo = this.conceptoTributo
          }
          this.getPersona(p_nrocta.toUpperCase(), this.codigo);
          
          for (var i = 0; i < response.length; i++) {
            if (response[i].situacion_deuda == "PL") {
              this.situacion = true;
              return;
            } else if (response[i].situacion_deuda == "JU") {
              this.situacion = true;
              return;
            } else this.situacion = false;
          }
          this.montoTt = 0;
        });
    } else {
      alert("Debe ingresar el número de cuenta y cantidad de días.");
    }
  }

  //funcion para obtner el tipotributos


  getPersona(p_nrocta: string, p_codigo: string): void {


    this.isVisible = true;
   
    this.service.getPersona(p_nrocta, p_codigo).subscribe((response) => {
      this.tributopersona = response;

      this.isVisible = false;
    });
  }

  getColorInteres(interes: number): string {
    if (interes > 0)
       return "red";

  }

  getIndex(item, nroCta: string): void {
    debugger;
    if(this.tributoPP !='FIFI')
    {
      if (item.seleccionado) {
        if (item.nro_cuota === "000") {
          this.arr.push({
            idObligacion: item.id_obligacion,
            idTributoC: item.id_tributo_contribuyente,
            deudaAct: item.deuda_actualizada,
            Cuota: item.nro_cuota,
            Int: item.intereses,
            CapitalFacturado: item.capital_facturado,
            AnioC: item.ano_cuota,
            Concepto: this.titulo,
            ClaveBien: nroCta,
          });
  
          for (var i = 0; i < this.items.length; i++) {
            if (
              this.items[i].nro_cuota !== "000" &&
              this.items[i].ano_cuota === item.ano_cuota
            ) {
              this.items[i].deshabilitar = true;
              this.items[i].seleccionado = false;
            }
          }
        } else {
          this.arr.push({
            idObligacion: item.id_obligacion,
            idTributoC: item.id_tributo_contribuyente,
            deudaAct: item.deuda_actualizada,
            Cuota: item.nro_cuota,
            Int: item.intereses,
            CapitalFacturado: item.capital_facturado,
            AnioC: item.ano_cuota,
            Concepto: this.titulo,
            ClaveBien: nroCta,
          });
          
  
          for (var i = 0; i < this.items.length; i++) {
            if (
              this.items[i].nro_cuota === "000" &&
              this.items[i].ano_cuota === item.ano_cuota
            ) {
              this.items[i].deshabilitar = true;
              this.items[i].seleccionado = false;
            }
          }
        }
      } else {
       this.index = -1;
        for (var i = 0; i < this.arr.length; i++) {
          if (item.id_obligacion === this.arr[i].idObligacion)
              this.index = this.arr.indexOf(this.arr[i]);
  
              if (this.index > -1) {
                this.arr.splice(i, 1);
  
             }
  
        }
  
  
        if (item.nro_cuota === "000") {
          for (var i = 0; i < this.items.length; i++) {
            if (
              this.items[i].nro_cuota !== "000" &&
              this.items[i].ano_cuota === item.ano_cuota
            ) {
              this.items[i].deshabilitar = false;
            }
          }
        } else {
          var des = false;
          for (var i = 0; i < this.items.length; i++) {
            if (
              this.items[i].nro_cuota !== "000" &&
              this.items[i].ano_cuota === item.ano_cuota
            )
              if (this.items[i].seleccionado) {
                des = true;
              }
          }
  
          for (var i = 0; i < this.items.length; i++) {
            if (
              this.items[i].nro_cuota === "000" &&
              this.items[i].ano_cuota === item.ano_cuota
            )
              this.items[i].deshabilitar = des;
          }
        }
      }
      this.montoTt = 0;
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].seleccionado) {
          this.montoTt += this.items[i].deuda_actualizada;
        }
      }
  
      if (this.arr.length > 0) {
        this.botonCedulon = true;
        this.botonP360 = true;
      } else {
        this.botonCedulon = false;
        this.botonP360 = false;
      }

    }
    else{
      if (item.seleccionado) 
      {
        this.arr.push({
          idObligacion: item.id_obligacion,
          idTributoC: item.id_tributo_contribuyente,
          deudaAct: item.saldo,
          Cuota: item.nro_cuota,
          Int: item.recargo,
          CapitalFacturado: item.monto_cuota,
          AnioC: item.ano_cuota,
          Concepto: this.titulo,
          ClaveBien: nroCta,
        });

        this.montoTt = 0;
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].seleccionado) {
          this.montoTt += this.items[i].saldo;
        }
      }
  
      if (this.arr.length > 0) {
        this.botonCedulon = true;
        this.botonP360 = true;
      } else {
        this.botonCedulon = false;
        this.botonP360 = false;
      }
    }
    else {
        var index = this.arr.indexOf({ idObligacion: item.id_obligacion,
          idTributoC: item.id_tributo_contribuyente,
          deudaAct: item.saldo,
          Cuota: item.nro_cuota,
          Int: item.recargo,
          CapitalFacturado: item.monto_cuota,
          AnioC: item.ano_cuota,
          Concepto: this.titulo,
          ClaveBien: nroCta,});
        this.arr.splice(index, 2);
        this.montoTt = 0;
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].seleccionado) {
          this.montoTt += this.items[i].saldo;
        }
      }
  
      if (this.arr.length > 0) {
        this.botonCedulon = true;
        this.botonP360 = true;
      } else {
        this.botonCedulon = false;
        this.botonP360 = false;
      }
    }

    
    }
    
  }

  cedulon(selected: string): void {
    debugger;
    var seleccionados = this.items.filter(function (res) {
      if (res.seleccionado) {
        return res;
      }
    });

    var datos = {
      tipo_comprobante: 2,
      id_tributo_contribuyente: seleccionados[0].id_tributo_contribuyente,
      cantidad_dias: selected,
      items: [],
    };

    for (var i = 0; i < seleccionados.length; i++) {
      var fecha;
      if(this.tributoPP !='FIFI')
        {
          fecha = seleccionados[i].fecha_primer_vencimiento;
        }
        else{
          fecha =  seleccionados[i].fecha_vencimiento_cuota;
        }
      var item = {
        id_obligacion: seleccionados[i].id_obligacion,
        fecha_vto: fecha,
       

      };
      
      datos.items.push(item);
    }
    const p = Object.assign({}, this.comprobante, datos);
    debugger;
    this.service.addComprobante(p)
    .subscribe(response =>  {
      debugger;
      if (this.codigo == 'AUAU'){
        var url = `${environment.urlReporte}reporteCedulonAU?reporteId=2&parametros=${response}`
      }
      else if  (this.codigo == 'ININ')
        var url = `${environment.urlReporte}reporteCedulonAU?reporteId=3&parametros=${response}`
      else if  (this.codigo == 'OBSA')
        var url = `${environment.urlReporte}reporteCedulonAU?reporteId=6&parametros=${response}`
      else if  (this.codigo == 'FIFI')
        var url = `${environment.urlReporte}reporteCedulonAU?reporteId=8&parametros=${response}`
      else if(this.codigo == 'CICI')
        var url =  `${environment.urlReporte}reporteCedulonAU?reporteId=4&parametros=${response}`
      else if  (this.codigo == this.conceptoTributo)
      // Ingresos\DDJJ.html
        var url = `${environment.urlReporte}reporteCedulonAU?reporteId=41&parametros=${response}`
        // https://www.sigemyt.com/reportesapi/api/INGRESOS/reporteCedulonAU?reporteId=31&parametros=5704426
      this.arr = [];
      window.open(url);
    });

  }

  getColor(situacion_deuda: string): string {
    switch (situacion_deuda) {
      case "PL":
        return "#ff6700";
      case "JU":
        return "#ff3d3d";
    }
  }

  getSituacion(situacion_deuda: string): boolean {
    switch (situacion_deuda) {
      case "PL":
        return true;
      case "JU":
        return true;
      case "DN":
        return false;
    }
  }

  pagos360(): void {
   /*  if(this.items.length > 0){
      this.items = [];
      this.tributopersona = null;
      console.log(this.items);
    } */
    const scrollStrategy = this.overlay.scrollStrategies.reposition();
    const dialogRef = this.dialog.open(Pagos360Component, {
      panelClass: "",
      width: '2000px',
      height: '800px',
      direction: 'ltr',
      scrollStrategy,
      data : {nrocta : this.nrocta, monto: this.montoTt, arr : this.arr, dias : this.selected, Concepto: this.titulo},
    });

    dialogRef.afterClosed().subscribe(result => {

    });


  }

 debitoAutomatico(){
    // var url = "https://sandbox-trasus.autogestion.io/adhesion?pKey=?tgpC4nXZ8bC?LZ";
    // "https://sandbox-trasus.autogestion.io/adhesion?pKey=?tgpC4nXZ8bC?LZ"

   //this.tributoContribuyente =this.arr[0].idTributoC;
   this.arrayPago360  = [this.arr[0].idTributoC];
  
   console.log("Debito automatico"+this.tributoContribuyente)
    let datosAdhesion = 'idObligacion';
  //  ``
   window.location.href = `https://sandbox-trasus.autogestion.io/adhesion?pKey=pcdDHkHsJdSdjwg&pReference=${this.arrayPago360}`;
   
 }

  ngAfterViewInit(): void {
    //this.columns = this.getColumns();
    //this.ref.detectChanges();
  }


}
